import {useQuery} from "react-query";
import DataRequest from '../queries/DataRequest';
import {DocumentResponse} from "../types/responses/documentResponse";

export const getDownloads = (inspectionId: string, user: any) => {
    return useQuery<DocumentResponse>(["documents", inspectionId], async () => {
        return await DataRequest(inspectionId, "documents", user);
    });
}